import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { Lightbox } from 'ngx-lightbox';

import { Showcase } from '../../../shared/data/models/collections/showcase';
import { Request } from '../../../shared/data/services/request-enum';
import { AbstractLocalizedComponent } from '../../../shared/ui/abstract.localized.component';

@Component({
  selector: 'placeme-showcase',
  templateUrl: './showcase.component.html',
  styleUrls: ['./showcase.component.scss'],
})
export class ShowcaseComponent extends AbstractLocalizedComponent {
  album: { caption: string; src: string; thumb: string }[] = [];
  showcase: Showcase;

  constructor(
    private lightbox: Lightbox,
    private activatedRoute: ActivatedRoute
  ) {
    super();
  }

  close(): void {
    this.lightbox.close();
  }

  open(index: number): void {
    this.lightbox.open(this.album, index, {
      disableScrolling: true,
    });
  }

  protected loadData(locale: string): void {
    this.collectionsService
      .query<{ showcaseBySlug: Showcase }>(Request.SHOWCASE, {
        slug: this.activatedRoute.snapshot.params.slug,
        locale,
      })
      .subscribe((data: { showcaseBySlug: Showcase }) => {
        this.showcase = data.showcaseBySlug;
        data.showcaseBySlug.images.forEach(image => {
          this.album.push({
            src: image.url,
            caption: data.showcaseBySlug.seo.title,
            thumb: image.url,
          });
        });
      });
  }
}
